export default "__VITE_ASSET__DDchOoK0__"